import { collection, getDocs, deleteDoc, doc, updateDoc, deleteField, FieldValue } from "firebase/firestore";
import { db } from "../firebase";
import { NightRow } from "./closeEvent";

/**
 * Poistaa tapahtuman ja sen alikokoelmat.
 *
 * Firestore ei poista alikokoelmia dokumentin mukana. Pelkkä deleteDoc
 * tapahtumalle jättää `games`- ja `participants`-dokumentit kantaan orvoiksi:
 * ne eivät näy missään näkymässä, mutta ne ovat siellä. Siksi alikokoelmat
 * haetaan ja poistetaan erikseen ennen tapahtumadokumenttia.
 */
export async function deleteEventDeep(clubId: string, eventId: string) {
  for (const sub of ["games", "participants"] as const) {
    const snap = await getDocs(collection(db, "clubs", clubId, "events", eventId, sub));
    await Promise.all(snap.docs.map(d => deleteDoc(d.ref)));
  }
  await deleteDoc(doc(db, "clubs", clubId, "events", eventId));
}

/**
 * Kirjoittaa illan sijoitukset ja läsnäolot osallistujariveille
 * (`nightResults`, src/utils/closeEvent.ts). Yhden rivin epäonnistuminen
 * ei estä muita; palauttaa niiden nimet joita ei saatu kirjattua.
 */
export async function writeNightResults(clubId: string, eventId: string, rows: NightRow[]): Promise<string[]> {
  const failed: string[] = [];
  await Promise.all(rows.map(async r => {
    if (Object.keys(r.patch).length === 0) return;
    const { finalPosition, ...rest } = r.patch;
    const data: { [k: string]: boolean | number | FieldValue } = { ...rest };
    if (finalPosition !== undefined) data.finalPosition = finalPosition === null ? deleteField() : finalPosition;
    try {
      await updateDoc(doc(db, "clubs", clubId, "events", eventId, "participants", r.participant.id), data);
    } catch (err) {
      failed.push(r.participant.displayName);
      console.error("writeNightResults", r.participant.displayName, err);
    }
  }));
  return failed;
}
